import React from "react";
import { BookshelfPage } from "@/components/bookshelf";

export default function Bookshelf() {
  return <BookshelfPage />;
}
